export default {
  h1: {
    fontWeight: 600,
    fontSize: 55,
    lineHeight: "66px",
    fontFamily: "'Readex Pro', sans-serif",
    "@media(max-width:767px)": {
      fontSize: "34px !important",
      lineHeight: "42px",
    },
  },
  h2: {
    fontWeight: 600,
    fontSize: 40,
    lineHeight: "40px",
    fontFamily: "'Readex Pro', sans-serif",
    wordBreak: "break-word",
    "@media(max-width:767px)": {
      fontSize: "25px !important",
      lineHeight: "30px !important",
    },
    "@media(max-width:460px)": {
      fontSize: "20px !important",
      lineHeight: "20px !important",
    },
  },
  h3: {
    fontWeight: 600,
    fontSize: 28,
    lineHeight: "40px",
    fontFamily: "'Readex Pro', sans-serif",
    "@media(max-width:767px)": {
      fontSize: "23px !important",
    },
  },
  h4: {
    fontWeight: 600,
    fontSize: 25,
    lineHeight: "30px",
    fontFamily: "'Readex Pro', sans-serif",
    "@media(max-width:767px)": {
      fontSize: "20px !important",
    },
  },
  h5: {
    fontWeight: 600,
    fontSize: 20,
    lineHeight: "30px",
    fontFamily: "'Readex Pro', sans-serif",
    "@media(max-width:767px)": {
      fontSize: "18px !important",
    },
  },
  h6: {
    fontWeight: 500,
    fontSize: 18,
    lineHeight: "24px",
    fontFamily: "'Readex Pro', sans-serif",
    "@media(max-width:767px)": {
      lineHeight: "22px",
      fontSize: "14px !important",
    },
  },
  overline: {
    fontWeight: 500,
    fontFamily: "'Readex Pro', sans-serif",
  },
  button: {
    textTransform: "capitalize",
    borderRadius: 27,
    fontFamily: "'Readex Pro', sans-serif",
  },
  body2: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: "21px",
    fontFamily: "'Readex Pro', sans-serif",
    "@media(max-width:767px)": {
      fontSize: "12px",
      lineHeight: "22px",
    },
  },
  body1: {
    fontWeight: 300,
    lineHeight: "22px",
    fontSize: 13,
    letterSpacing: "0px",
    fontFamily: "'Readex Pro', sans-serif",
  },
};
